/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.64
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The MediaDTO model module.
 * @module model/MediaDTO
 * @version 1.0.1
 */
export default class MediaDTO {
  /**
   * Constructs a new <code>MediaDTO</code>.
   * @alias module:model/MediaDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>MediaDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MediaDTO} obj Optional instance to populate.
   * @return {module:model/MediaDTO} The populated <code>MediaDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MediaDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('mediaUrl'))
        obj.mediaUrl = ApiClient.convertToType(data['mediaUrl'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
MediaDTO.prototype.id = undefined;

/**
 * @member {String} title
 */
MediaDTO.prototype.title = undefined;

/**
 * @member {String} description
 */
MediaDTO.prototype.description = undefined;

/**
 * @member {String} mediaUrl
 */
MediaDTO.prototype.mediaUrl = undefined;

